// extracted by mini-css-extract-plugin
export var additionalHighlightRow = "Results-module--additionalHighlightRow--dfa1c";
export var casinoCategoryIconContainer = "Results-module--casinoCategoryIconContainer--78362";
export var casinoGameImage = "Results-module--casinoGameImage--c1cf6";
export var casinoGameImageContainer = "Results-module--casinoGameImageContainer--e1dac";
export var casinoProviderIconContainer = "Results-module--casinoProviderIconContainer--ba107";
export var casinoProviderImage = "Results-module--casinoProviderImage--bcbfb";
export var casinoProviderImageContainer = "Results-module--casinoProviderImageContainer--c1b15";
export var cluster = "Results-module--cluster--7168d";
export var content = "Results-module--content--cac4d";
export var countdown = "Results-module--countdown--9524b";
export var displayInlineBlock = "Results-module--displayInlineBlock--ce0bf";
export var highlightRow = "Results-module--highlightRow--77c42";
export var icon = "Results-module--icon--374f8";
export var iconWrapper = "Results-module--iconWrapper--efb51";
export var index = "Results-module--index--faf3d";
export var indexHeader = "Results-module--indexHeader--7be96";
export var indexHeaderSticky = "Results-module--indexHeaderSticky--60320";
export var indexName = "Results-module--indexName--31448";
export var inline = "Results-module--inline--bea3c";
export var link = "Results-module--link--0c873";
export var message = "Results-module--message--297b5";
export var moreResults = "Results-module--moreResults--dbcf3";
export var moreResultsInner = "Results-module--moreResultsInner--0d5e4";
export var noResultsContainer = "Results-module--noResultsContainer--7406f";
export var noResultsSubtitle = "Results-module--noResultsSubtitle--80619";
export var promoIcon = "Results-module--promoIcon--17201";
export var raceNumber = "Results-module--raceNumber--84bd8";
export var resultsContainer = "Results-module--resultsContainer--ebff4";
export var row = "Results-module--row--f42ba";
export var rows = "Results-module--rows--7c576";
export var subTitle = "Results-module--subTitle--f94de";
export var title = "Results-module--title--275ff";